// extracted by mini-css-extract-plugin
export default {"main":"FaqSection_main__eqLUQ","header":"FaqSection_header__2ME7n","removeBut":"FaqSection_removeBut__1GsZU"};